import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class ApiUrlService {
  private readonly apiPath = '/api/4XKnXFATT4CA';

  /**
   * Get API URL based on current location
   * - If localhost: use http://localhost:8000 (backend port)
   * - If tenant.localhost: use http://tenant.localhost:8000 (backend port with tenant subdomain)
   * - Otherwise: use relative path (production)
   */
  getApiUrl(): string {
    // Check if running in browser
    if (typeof window !== 'undefined') {
      const hostname = window.location.hostname;
      const protocol = window.location.protocol; // http: or https:

      // If localhost or 127.0.0.1, use port 8000 for backend
      if (hostname === 'localhost' || hostname === '127.0.0.1') {
        return `http://localhost:8000${this.apiPath}`;
      }

      // If tenant subdomain (e.g., tenant1.localhost), keep the subdomain and use port 8000
      if (hostname.includes('.localhost')) {
        return `http://${hostname}:8000${this.apiPath}`;
      }
    }

    // Default: relative path for production
    return this.apiPath;
  }
}
